var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29 31.7538C31.0327 31.2097 32.8728 29.8921 34.3628 28.0246C35.72 29.8242 37.9629 31 40.5 31C44.6421 31 48 27.866 48 24C48 21.5449 46.6458 19.385 44.5966 18.1355C46.0748 16.857 47 15.0293 47 13C47 9.13401 43.6421 6 39.5 6C38.278 6 37.1242 6.27278 36.1048 6.75666C34.0601 2.66799 30.6975 0 26.8958 0C24.025 0 21.4046 1.52138 19.413 4.02704C18.2738 3.37556 16.9339 3 15.5 3C11.3579 3 8 6.13401 8 10C8 10.3821 8.0328 10.757 8.09591 11.1225C4.62488 11.736 2 14.5819 2 18C2 21.4971 4.74757 24.3952 8.33784 24.9165C8.11828 25.5746 8 26.2744 8 27C8 30.866 11.3579 34 15.5 34C18.2785 34 20.704 32.5899 22 30.4946V27.5V20L25.5 26.125L29 20V27.5V31.7538Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 33C22 33 24.25 33.5992 25.5 33.5992C26.75 33.5992 29 33 29 33V40.5V47.25L34 49.2158V50H17V49.2158L22 47.25V40.5V33Z",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.b106ca13c70223b48be2e8e0e7612f57.svg";
export { ForwardRef as ReactComponent };